<template>
  <div class="RiskWarning">
    <EmptyTip :show="apiData.length == 0"></EmptyTip>
    <van-steps direction="vertical" active-color="#999" inactive-color="#999" v-loading="detailLoading">
      <van-step v-for="risk in apiData" :key="risk">
        <p>
          <span class="RiskWarning-release_time">{{ risk.release_time }}</span>
          <span class="RiskWarning-source">{{ risk.source }}</span>
        </p>
        <p class="RiskWarning-title" @click="showDetail(risk)">
          {{ risk.title }}
        </p>
        <template #active-icon>
          <i class="iconColor">•</i>
        </template>
        <template #inactive-icon>
          <i class="iconColor">•</i>
        </template>
      </van-step>
    </van-steps>
    <NewsDetailShow
      v-if="newsDetailVisible"
      :visible="newsDetailVisible"
      :newsDetailData="newsDetailData"
      @changeVisible="handleNewsDetailVisible"
    ></NewsDetailShow>
  </div>
</template>
<script>
import EmptyTip from "@/components/EmptyTip.vue";
import NewsDetailShow from "@/components/NewsDetailShow.vue";
import api from "@/api/api";

export default {
  components: {
    EmptyTip,
    NewsDetailShow,
  },
  props: {
    apiData: Array,
  },
  watch: {
    apiData: {
      handler(newVal, oldVal) {
        console.log("newsNewVal", newVal);
        console.log("newsOldVal", oldVal);
        this.newsDetailVisible = false;
      },
      deep: true,
    },
  },
  data() {
    return {
      detailLoading: false,
      newsDetailData: "",
      newsDetailVisible: false,
    };
  },
  methods: {
    showDetail(item) {
      console.log("item:", item);
      this.detailLoading = true
      api.getNewsDetailById({news_id:item.id})
      .then((res) => {
        console.log("获取产业前沿新闻详情", res);
        this.newsDetailData = res.data
        this.detailLoading = false
        this.newsDetailVisible = true
      })
      .catch((err) => {
        console.log(err);
        this.detailLoading = false;
      });
    },
    handleNewsDetailVisible(val){
      this.newsDetailVisible=val
    },
  },
};
</script>
<style lang="scss" scoped>
.RiskWarning {
  position: relative;
  .iconColor {
    color: #de868f;
    font-size: 45px;
  }
  &-release_time,
  &-source {
    color: rgb(108, 108, 108);
    font-size: 13px;
  }
  &-source {
    margin-left: 20px;
  }
  &-title {
    margin-top: 5px;
    color: black;
    cursor: pointer;
  }
}
</style>
